import Vue from 'vue'
import Router from 'vue-router'
import WelcomeView from ".././app/views/WelcomeView";
import FindStoreView from ".././app/views/FindStoreView";
import DigitalReceiptView from ".././app/views/DigitalReceiptView";
import OrderView from ".././app/views/OrderView";
import ProductSearchView from ".././app/views/ProductSearchView";
import ProductView from ".././app/views/ProductView";
import HomeView from "../app/views/HomeView";
import GroupView from "../app/views/GroupView";
import ReciboPagamentoLinkMercadoPago from "../app/views/ReciboPagamentoLinkMercadoPago";
import Pesquisa from "../app/views/Pesquisa.vue";


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'FindStoreView',
      component: FindStoreView
    },
    {
      path: '/:empresa',
      name: 'WelcomeView',
      component: WelcomeView
    },
    {
      path: '/:empresa/menu/pesquisar',
      name: 'Pesquisa',
      component: Pesquisa
    },
    {
      path: '/:empresa/menu',
      name: 'HomeView',
      component: HomeView
    },
    {
      path: '/:empresa/menu/produto/:id',
      name: 'Produto',
      component: ProductView
    },
    {
      path: '/:empresa/menu/pesquisar',
      name: 'Pesquisa',
      component: ProductSearchView
    },
    {
      path: '/:empresa/menu/grupo/:id/secao/:id',
      name: 'GroupView',
      component: GroupView
    },
    {
      path: '/:empresa/pedido',
      name: 'Pedido',
      component: OrderView
    },
    {
      path: '/:empresa/recibo-digital/:pedido',
      name: 'ReciboDigital',
      component: DigitalReceiptView
    },
    {
      path: '/404/nao-localizado/:empresa',
      name: 'EmpresaNaoLocalizada',
      component: FindStoreView
    },
    {
      path: '/pagamentos/mercadopago/rastrear/:id',
      name: 'ReciboPagamentoLinkMercadoPago',
      component: ReciboPagamentoLinkMercadoPago
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js